yTos.utils.namespace('yTos.configuration.requireJSConfig.paths');

yTos.configuration.requireJSConfig.paths['ytos.item'] = 'model.item-1.11.0/model.item';
//yTos.configuration.requireJSConfig.paths['ytos.item'] = '/jsrepo/model.item/src/model.item';
yTos.configuration.requireJSConfig.paths['ytos.share'] = 'model.share-0.1.1/model.share';
//yTos.configuration.requireJSConfig.paths['ytos.share'] = '/jsrepo/model.share/src/model.share';

yTos.configuration.requireJSConfig.paths['ytos.product'] = 'model.product-0.8.0/model.product';
// yTos.configuration.requireJSConfig.paths['ytos.product'] = '/jsrepo/model.product/src/model.product';


// product.image should also be included here because
// product.imageZoom extends it.
yTos.configuration.requireJSConfig.paths['product.image'] = 'product.image-1.0.2/product.image';
//yTos.configuration.requireJSConfig.paths['product.image'] = '/jsrepo/product.image/src/product.image';

// product.selectedSizeInfo should also be included here because
// product.selectedSizeConversionInfo extends it.
yTos.configuration.requireJSConfig.paths['product.selectedSizeInfo'] = 'product.selectedSizeInfo-0.5.1/product.selectedSizeInfo';
// yTos.configuration.requireJSConfig.paths['product.selectedSizeInfo'] = '/jsrepo/product.selectedSizeInfo/src/product.selectedSizeInfo';
